var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alerts)?_c('div',{staticClass:"alert-container"},[_c('v-slide-x-reverse-transition',{attrs:{"group":""}},[_vm._l((_vm.alerts),function(alert){
var _obj;
return [_c('div',{key:alert.id,staticClass:"alert-container-alert",class:( _obj = {}, _obj[("type-" + (alert.type))] = true, _obj )},[_vm._v(" "+_vm._s(alert.title)+" ")])]})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }